// extracted by mini-css-extract-plugin
module.exports = {"root":"radioGroup_root__SH8xM gap-[20px] grid","radioContainer":"radioGroup_radioContainer__i0Ah5","message":"radioGroup_message__wtPLI mt-xs text-colorDefault"};